// Sections « bz- » : menu mobile, menus déroulants, carrousels d'avis, accordéons du pied de page.
(() => {
  const mobile = window.matchMedia('(max-width: 989px)');

  function initHeader(root) {
    // Menu mobile façon Fruggies : le panneau s'ouvre sous l'en-tête, qui passe en blanc avec une croix
    const drawer = root.querySelector('[data-bz-drawer]');
    const toggle = root.querySelector('[data-bz-menu-toggle]');
    const place = () => { drawer.style.setProperty('--bz-drawer-top', `${Math.max(0, root.getBoundingClientRect().bottom)}px`); };
    const setOpen = (open) => {
      if (!drawer) return;
      if (open) place();
      drawer.hidden = !open;
      root.classList.toggle('is-menu-open', open);
      toggle?.setAttribute('aria-expanded', String(open));
      toggle?.setAttribute('aria-label', open ? 'Fermer le menu' : 'Ouvrir le menu');
      if (open) document.documentElement.setAttribute('scroll-lock', '');
      else document.documentElement.removeAttribute('scroll-lock');
    };
    toggle?.addEventListener('click', () => setOpen(drawer.hidden));
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && drawer && !drawer.hidden) setOpen(false); });
    mobile.addEventListener('change', () => { if (!mobile.matches) setOpen(false); });
    window.addEventListener('resize', () => { if (drawer && !drawer.hidden) place(); });

    // Accordéons du menu
    drawer?.querySelectorAll('[data-bz-acc]').forEach((item) => {
      const btn = item.querySelector('[data-bz-acc-trigger]');
      btn?.addEventListener('click', () => {
        const open = !item.classList.contains('is-open');
        item.classList.toggle('is-open', open);
        btn.setAttribute('aria-expanded', String(open));
      });
      // Onglets (cartes)
      const tabs = [...item.querySelectorAll('[data-bz-tab-btn]')];
      const panels = [...item.querySelectorAll('[data-bz-tab-panel]')];
      tabs.forEach((tab) => tab.addEventListener('click', () => {
        tabs.forEach((t) => { t.classList.toggle('is-on', t === tab); t.setAttribute('aria-selected', String(t === tab)); });
        panels.forEach((pn) => pn.classList.toggle('is-on', pn.dataset.bzTabPanel === tab.dataset.bzTabBtn));
      }));
    });

    // Méga-menu (ordinateur) : survol d'une rubrique, fermeture en quittant l'en-tête, clic et clavier aussi
    const mega = root.querySelector('[data-bz-mega]');
    if (mega) {
      const triggers = [...root.querySelectorAll('[data-bz-mega-trigger]')];
      const contents = [...mega.querySelectorAll('[data-bz-mega-content]')];
      const wrap = mega.querySelector('[data-bz-mega-wrap]');
      const row = root.querySelector('.bz-header__row');
      let current = null;
      let timer = null;
      const openMega = (id) => {
        clearTimeout(timer);
        contents.forEach((c) => { c.hidden = c.dataset.bzMegaContent !== id; });
        triggers.forEach((t) => t.setAttribute('aria-expanded', String(t.dataset.bzMegaTrigger === id)));
        mega.style.setProperty('--bz-mega-h', `${wrap.offsetHeight}px`);
        root.classList.add('is-mega');
        current = id;
      };
      const closeMega = () => {
        clearTimeout(timer);
        root.classList.remove('is-mega');
        mega.style.setProperty('--bz-mega-h', '62px');
        triggers.forEach((t) => t.setAttribute('aria-expanded', 'false'));
        current = null;
      };
      triggers.forEach((t) => {
        t.addEventListener('mouseenter', () => { if (!mobile.matches) openMega(t.dataset.bzMegaTrigger); });
        t.addEventListener('click', () => (current === t.dataset.bzMegaTrigger ? closeMega() : openMega(t.dataset.bzMegaTrigger)));
      });
      root.querySelectorAll('[data-bz-mega-close], .bz-logo').forEach((el) => el.addEventListener('mouseenter', () => { if (current) closeMega(); }));
      row.addEventListener('mouseleave', () => { if (current) timer = setTimeout(closeMega, 180); });
      row.addEventListener('mouseenter', () => clearTimeout(timer));
      root.addEventListener('focusout', (e) => { if (current && !root.contains(e.relatedTarget)) closeMega(); });
      document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && current) closeMega(); });
      mobile.addEventListener('change', closeMega);
    }

    // Menus déroulants : survol sur desktop, clic au clavier ou au toucher
    root.querySelectorAll('[data-bz-dropdown]').forEach((item) => {
      const btn = item.querySelector('button');
      const open = (v) => { item.classList.toggle('is-open', v); btn?.setAttribute('aria-expanded', String(v)); };
      item.addEventListener('mouseenter', () => open(true));
      item.addEventListener('mouseleave', () => open(false));
      btn?.addEventListener('click', () => open(!item.classList.contains('is-open')));
      item.addEventListener('focusout', (e) => { if (!item.contains(e.relatedTarget)) open(false); });
    });
  }

  function initSlider(slider) {
    const track = slider.querySelector('[data-bz-track]');
    const prev = slider.querySelector('[data-bz-prev]');
    const next = slider.querySelector('[data-bz-next]');
    const dotsBox = slider.querySelector('[data-bz-dots]');
    const cards = [...track.children];
    if (cards.length < 2) return;
    const step = () => cards[1].offsetLeft - cards[0].offsetLeft;
    const perView = () => Math.max(1, Math.round(track.clientWidth / step()));
    const pages = () => Math.max(1, cards.length - perView() + 1);

    const update = () => {
      const i = Math.round(track.scrollLeft / step());
      [...dotsBox.children].forEach((d, k) => d.classList.toggle('is-on', k === i));
      prev.disabled = i <= 0;
      next.disabled = i >= pages() - 1;
    };
    const renderDots = () => {
      dotsBox.innerHTML = '';
      for (let i = 0; i < pages(); i++) {
        const b = document.createElement('button');
        b.type = 'button';
        b.setAttribute('aria-label', `${i + 1}`);
        b.addEventListener('click', () => track.scrollTo({ left: i * step() }));
        dotsBox.appendChild(b);
      }
      update();
    };
    prev.addEventListener('click', () => track.scrollBy({ left: -step() }));
    next.addEventListener('click', () => track.scrollBy({ left: step() }));
    track.addEventListener('scroll', () => requestAnimationFrame(update), { passive: true });
    window.addEventListener('resize', renderDots);
    renderDots();
  }

  function initFooter(root) {
    const cols = root.querySelectorAll('.bz-fcol');
    const sync = () => cols.forEach((c) => { c.open = !mobile.matches; });
    mobile.addEventListener('change', sync);
    sync();
  }

  // FAQ : onglets par thème
  function initFaq(root) {
    const tabs = [...root.querySelectorAll('[data-bz-faq-tab]')];
    const items = [...root.querySelectorAll('[data-bz-faq-cat]')];
    tabs.forEach((tab) => tab.addEventListener('click', () => {
      tabs.forEach((t) => { t.classList.toggle('is-on', t === tab); t.setAttribute('aria-selected', String(t === tab)); });
      items.forEach((item) => { item.hidden = item.dataset.bzFaqCat !== tab.dataset.bzFaqTab; });
    }));
  }

  // Vidéo du héros : à l'arrêt si l'utilisateur limite les animations, relancée si le navigateur l'a bloquée
  function initHeroVideo(video) {
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
    if (reduce.matches) { video.removeAttribute('autoplay'); video.pause(); return; }
    video.muted = true;
    const play = () => video.play().catch(() => {});
    if (video.readyState >= 2) play(); else video.addEventListener('canplay', play, { once: true });
  }

  function init(scope = document) {
    scope.querySelectorAll('[data-bz-header]').forEach(initHeader);
    scope.querySelectorAll('[data-bz-slider]').forEach(initSlider);
    scope.querySelectorAll('[data-bz-footer]').forEach(initFooter);
    scope.querySelectorAll('[data-bz-faq]').forEach(initFaq);
    scope.querySelectorAll('[data-bz-hero-video]').forEach(initHeroVideo);
  }

  init();
  // Éditeur de thème : réinitialise une section rechargée
  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();
